<template>
  <div class="Handover">
    <div class="twolabs">
      <el-tabs tab-position="left" type="card" style="height: 200px;">
        <el-tab-pane label="Account Detail">
          <div class="first-lab-right">
            <div class="user-breviary">{{userInfo.firstName}}</div>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Name </span>{{userInfo.agentName}}</p>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Job No. </span>{{userInfo.agentCode}}</p>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Account</span>{{userInfo.userName}}</p>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Branches</span>{{userInfo.branchName}}</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Change Password">
          <div class="second-lab-right">
            <el-row>
              <el-col>
                <el-form :inline="true" :model="formInline" class="demo-form-inline wordorder-form">
                  <el-col :span="24">
                    <el-form-item style="marginRight: 0;" label="Previous Password" label-width="200px" class="pws">
                      <el-input type="password" v-model="formInline.oldPassword" :title="formInline.orderNo" placeholder="6-16 Letters Capitalize and Lowercase"></el-input>
                    </el-form-item>
                  </el-col :span="24">
                  <el-col>
                    <el-form-item style="marginRight: 0;" label="Setup New Password" label-width="200px" class="pws">
                      <el-input type="password" v-model="formInline.newPassword" :title="formInline.orderNo" placeholder="6-16 Letters Capitalize and Lowercase"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="Confirm Password" label-width="200px" class="pws">
                      <el-input type="password" v-model="formInline.againNewPassword" :title="formInline.orderNo" placeholder="6-16 Letters Capitalize and Lowercase"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-form-item>
                    <el-button type="primary" style="position: absolute;" @click="getDataList">Confirm</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import INTERFACE from '../../interface'
//  import globalConfig from '../../config'

export default {
  components: {
  },
  data() {
    return {
      I18n: window.I18n,
      userInfo: {
        agentName: '',
        agentCode: '',
        userName: '',
        branchName: '',
        firstName: ''
      },
      formInline: {
        startTime: '',
        endTime: '',
        organization: [],
        oldPassword: '',
        newPassword: '',
        againNewPassword: '',
        passportNo: ''
      }
    }
  },
  created() {
    INTERFACE.getuserInfo().then(data => {
      console.log(data.data)
      this.userInfo = data.data
    })
  },
  methods: {
    // 修改密码
    getDataList() {
      if (!this.userInfo.userName) {
        return window.Warning('user name does not exist')
      } else if (!this.formInline.newPassword || !this.formInline.againNewPassword) {
        return window.Warning('new password can not be empty')
      } else if (!this.formInline.oldPassword) {
        return window.Warning('old ciphers cant be empty')
      } else if (this.formInline.newPassword && this.formInline.againNewPassword) {
        if (this.formInline.newPassword !== this.formInline.againNewPassword) {
          return window.Warning('two inconsistencies in cipher input')
        }
        var passwordReg = /^\w{6,16}$/
        var isLegal = passwordReg.test(this.formInline.newPassword)
        if (!isLegal) {
          return window.Warning('new password is invaild')
        }
      }
      let parms = this.getParam()
      INTERFACE.changePassword(parms).then(data => {
        if (data.data.error === 'SUCCESS') {
          this.$notify({
            title: 'Success',
            message: data.data.message,
            type: 'success'
          });
          this.formInline.oldPassword = ''
          this.formInline.newPassword = ''
          this.formInline.againNewPassword = ''
        } else {
          this.$notify({
            title: 'Error',
            message: data.data.message,
            type: 'error'
          });
        }
      })
    },
    // 组装参数
    getParam() {
      return {
        username: this.userInfo.userName,
        oldPassword: this.formInline.oldPassword,
        newPassword: this.formInline.newPassword
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "index.styl"
</style>



// WEBPACK FOOTER //
// src/pages/Account/index.vue